import * as React from "react";
import PropTypes from 'prop-types';

const SvgAddressNew = props => {
  if (props.id !== "_svgaddressnew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M5.5 7h21A1.5 1.5 0 0128 8.5v15a1.5 1.5 0 01-1.5 1.5h-21A1.5 1.5 0 014 23.5v-15A1.5 1.5 0 015.5 7m11.25 10.5h7.875c.207 0 .375.168.375.375v1.5a.375.375 0 01-.375.375H16.75a.375.375 0 01-.375-.375v-1.5c0-.207.168-.375.375-.375m0-5.25h7.875c.207 0 .375.168.375.375v1.5a.375.375 0 01-.375.375H16.75a.375.375 0 01-.375-.375v-1.5c0-.207.168-.375.375-.375m-4.725 4.184c.295-.333.756-.913.775-1.852.022-1.079-.775-2.273-1.993-2.332h-.092c-1.227.059-2.02 1.254-1.998 2.332.019.941.482 1.522.777 1.854-.666.414-2.298 1.938-2.491 3.061a.215.215 0 00.214.252c.071-.003.387-.005 1.832-.005 2.07 0 5.203.005 5.234.005a.216.216 0 00.214-.249c-.178-1.139-1.822-2.675-2.472-3.066" /></svg>;
};

SvgAddressNew.displayName = "_svgaddressnew";
SvgAddressNew.propTypes = {
  id: PropTypes.string
};
SvgAddressNew.defaultProps = {
  id: ''
};
export default SvgAddressNew;